module.exports = __webpack_public_path__ + "img/no-image.f33fd46b.png";